var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSipTrunk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_sip_trunk",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1663",
    "data-name": "Rectangle 1663",
    width: 31.5,
    height: 31.043,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680",
    "data-name": "Rectangle 1680",
    width: 42,
    height: 42,
    fill: "#6639b7",
    opacity: 0.005
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sip_trunk-2",
    "data-name": "icon_sip_trunk",
    transform: "translate(5.25 5.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3700",
    "data-name": "Groupe 3700",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13525",
    "data-name": "Trac\\xE9 13525",
    d: "M83.195,73.019a3.639,3.639,0,0,1,.555-2.033.408.408,0,0,1,.338-.184h.645a.476.476,0,0,0,.456-.386l.341-1.573a.5.5,0,0,0-.308-.584l-1.374-.487a.453.453,0,0,0-.519.168,9.211,9.211,0,0,0,0,10.154.452.452,0,0,0,.519.168l1.374-.487a.5.5,0,0,0,.308-.584L85.19,75.62a.476.476,0,0,0-.456-.386H84.09a.408.408,0,0,1-.338-.184,3.639,3.639,0,0,1-.557-2.032",
    transform: "translate(-67.924 -56.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13526",
    "data-name": "Trac\\xE9 13526",
    d: "M33.7,130.035l-1.334,1.836-.424-.245a1.208,1.208,0,0,0-1.2,0l-.562.325,0,0-1.673.966a1.206,1.206,0,0,0-.5.561h0a1.19,1.19,0,0,0-.1.47v2.581a1.188,1.188,0,0,0,.592,1.03h0l.56.324,1.681.971h0a1.194,1.194,0,0,0,1.187,0h0l1.681-.971.56-.324a1.188,1.188,0,0,0,.592-1.03v-2.581a1.191,1.191,0,0,0-.1-.47h0a1.2,1.2,0,0,0-.371-.473l1.2-1.658a7.483,7.483,0,0,1-1.806-1.316",
    transform: "translate(-23.176 -107.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13527",
    "data-name": "Trac\\xE9 13527",
    d: "M52.446,52.21a6.225,6.225,0,1,1-6.225,6.225,6.225,6.225,0,0,1,6.225-6.225m0-2.026A8.251,8.251,0,1,0,60.7,58.435a8.26,8.26,0,0,0-8.251-8.251",
    transform: "translate(-36.696 -41.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13528",
    "data-name": "Trac\\xE9 13528",
    d: "M73.213,6.093h0l.56.323,1.158.669V9.4a7.488,7.488,0,0,1,2.235,0V7.085l1.158-.669.56-.323h0a1.188,1.188,0,0,0,.592-1.03V2.483a1.194,1.194,0,0,0-.1-.47h0a1.208,1.208,0,0,0-.5-.561L77.207.486l0,0L76.647.158a1.209,1.209,0,0,0-1.2,0l-.562.325,0,0-1.673.966a1.207,1.207,0,0,0-.5.561h0a1.194,1.194,0,0,0-.1.47V5.063a1.188,1.188,0,0,0,.592,1.03",
    transform: "translate(-60.299 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13529",
    "data-name": "Trac\\xE9 13529",
    d: "M141.054,54.763h0a1.206,1.206,0,0,0-.5-.561l-1.673-.966,0,0-.562-.325a1.208,1.208,0,0,0-1.2,0l-.562.325,0,0-1.673.966a1.207,1.207,0,0,0-.5.561h0a1.2,1.2,0,0,0-.1.47V56.5l-2.237.727a7.388,7.388,0,0,1,.692,2.125l1.961-.637a1.171,1.171,0,0,0,.176.128h0l.56.324,1.681.971h0a1.193,1.193,0,0,0,1.187,0h0L140,59.167l.56-.324h0a1.188,1.188,0,0,0,.592-1.03V55.233a1.2,1.2,0,0,0-.1-.47",
    transform: "translate(-109.65 -43.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13530",
    "data-name": "Trac\\xE9 13530",
    d: "M120.492,133.483a1.207,1.207,0,0,0-.5-.561l-1.673-.966,0,0-.562-.325a1.209,1.209,0,0,0-1.2,0l-.424.245-1.334-1.836A7.485,7.485,0,0,1,113,131.352l1.2,1.658a1.2,1.2,0,0,0-.371.473h0a1.194,1.194,0,0,0-.1.47v2.581a1.188,1.188,0,0,0,.592,1.03h0l.56.323,1.681.971h0a1.194,1.194,0,0,0,1.187,0h0l1.681-.971.56-.323h0a1.188,1.188,0,0,0,.592-1.03v-2.581a1.194,1.194,0,0,0-.1-.47h0",
    transform: "translate(-93.827 -107.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13531",
    "data-name": "Trac\\xE9 13531",
    d: "M6.263,58.843h0a1.171,1.171,0,0,0,.176-.128l1.961.637a7.386,7.386,0,0,1,.692-2.125L6.856,56.5V55.233a1.2,1.2,0,0,0-.1-.47h0a1.206,1.206,0,0,0-.5-.561l-1.673-.966,0,0-.562-.325a1.208,1.208,0,0,0-1.2,0l-.562.325,0,0L.6,54.2a1.207,1.207,0,0,0-.5.561h0a1.2,1.2,0,0,0-.1.47v2.581a1.188,1.188,0,0,0,.592,1.03h0l.56.324,1.681.971h0a1.193,1.193,0,0,0,1.187,0h0L5.7,59.167Z",
    transform: "translate(0 -43.799)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSipTrunk);
export default __webpack_public_path__ + "static/media/icon_sip_trunk.9a3ca66f63b7533d24599c8c26e60738.svg";
export { ForwardRef as ReactComponent };